module.exports = __webpack_public_path__ + "images/file_icons_v2/wpd-c778e8eb0c7549d93b3791e4ab3aaa1d.svg";